/**
 * Tour styles - CSS constants
 */

export const TOUR_STYLES_ID = 'app-tour-styles'

// Font family matching the app's design system
const FONT_FAMILY = "'Google Sans', ui-sans-serif, system-ui, sans-serif"

/**
 * Tour CSS styles
 */
export const TOUR_CSS = `
    /* Full-screen overlay to cover sidebar/navbar */
    .tour-overlay {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        background: rgba(0, 0, 0, 0.6) !important;
        z-index: 99999 !important;
        pointer-events: none !important;
    }

    /* Highlight element */
    .tour-highlight-element {
        position: relative !important;
        z-index: 100000 !important;
        padding: 12px !important;
        margin: -12px !important;
        border-radius: 8px !important;
        box-shadow: 0 0 0 4px white !important;
        isolation: isolate !important;
        pointer-events: auto !important;
    }

    /* Ensure children of highlighted element are visible */
    .tour-highlight-element > * {
        position: relative !important;
        z-index: 1 !important;
        opacity: 1 !important;
        visibility: visible !important;
    }

    .tour-highlight-element button,
    .tour-highlight-element a,
    .tour-highlight-element input,
    .tour-highlight-element select {
        position: relative !important;
        z-index: 2 !important;
        pointer-events: auto !important;
    }

    /* Popover container */
    .tour-popover-container {
        position: fixed;
        background: white;
        border-radius: 4px;
        padding: 20px;
        width: 380px;
        max-width: calc(100vw - 40px);
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
        z-index: 100001;
        font-family: ${FONT_FAMILY};
        animation: tour-popover-in 0.3s ease-out;
    }

    @keyframes tour-popover-in {
        from {
            opacity: 0;
            transform: translateY(10px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    /* Title */
    .tour-popover-container h3 {
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        font-family: ${FONT_FAMILY};
        line-height: 1.4;
    }

    /* Description */
    .tour-popover-container p {
        margin: 0 0 16px 0;
        font-size: 14px;
        color: #6b7280;
        line-height: 1.6;
        font-family: ${FONT_FAMILY};
        white-space: pre-line;
    }

    /* Close button */
    .tour-close {
        position: absolute;
        top: 12px;
        right: 12px;
        background: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
        color: #9ca3af;
        line-height: 1;
        width: 28px;
        height: 28px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
    }

    .tour-close:hover {
        background: #f3f4f6;
        color: #6b7280;
    }

    /* Navigation buttons */
    .tour-btn {
        padding: 8px 16px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        font-family: ${FONT_FAMILY};
    }

    .tour-btn-prev {
        border: 1px solid #e5e7eb;
        background: white;
        color: #374151;
    }

    .tour-btn-prev:hover {
        background: #f9fafb;
        border-color: #d1d5db;
    }

    .tour-btn-next {
        border: none;
        background: linear-gradient(135deg, #1A237E 0%, #3949AB 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(26, 35, 126, 0.3);
    }

    .tour-btn-next:hover {
        box-shadow: 0 4px 12px rgba(26, 35, 126, 0.4);
        transform: translateY(-1px);
    }

    /* Progress indicator */
    .tour-progress {
        font-size: 12px;
        color: #9ca3af;
        font-family: ${FONT_FAMILY};
    }

    /* Keyboard hint */
    .tour-keyboard-hint {
        font-size: 10px;
        color: #c9cdd3;
        font-family: ${FONT_FAMILY};
        margin-top: 2px;
    }

    .tour-keyboard-hint kbd {
        display: inline-block;
        padding: 1px 4px;
        font-size: 9px;
        font-family: ${FONT_FAMILY};
        background: #f3f4f6;
        border: 1px solid #e5e7eb;
        border-radius: 3px;
        margin: 0 1px;
    }

    /* Footer */
    .tour-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 4px;
    }

    .tour-footer-buttons {
        display: flex;
        gap: 8px;
    }

    /* Demo animations container */
    .tour-demo {
        margin: 12px 0 16px 0;
        padding: 16px;
        background: #f8fafc;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 80px;
        position: relative;
        overflow: hidden;
    }

    /* Drag demo animation */
    .tour-demo-drag {
        display: flex;
        gap: 8px;
        align-items: center;
    }

    .tour-demo-widget {
        width: 60px;
        height: 40px;
        background: linear-gradient(135deg, #1A237E 0%, #3949AB 100%);
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 10px;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(26, 35, 126, 0.3);
    }

    .tour-demo-widget.dragging {
        animation: tour-drag-move 2s ease-in-out infinite;
        opacity: 0.9;
        transform-origin: center;
    }

    .tour-demo-widget.placeholder {
        background: transparent;
        border: 2px dashed #cbd5e1;
        box-shadow: none;
        color: #94a3b8;
    }

    @keyframes tour-drag-move {
        0%, 100% { transform: translateX(0); }
        50% { transform: translateX(70px); }
    }

    /* Resize demo animation */
    .tour-demo-resize {
        position: relative;
    }

    .tour-demo-resize .tour-demo-widget {
        width: 80px;
        height: 50px;
        animation: tour-resize-grow 2s ease-in-out infinite;
    }

    .tour-demo-resize-handle {
        position: absolute;
        bottom: 4px;
        right: 4px;
        width: 12px;
        height: 12px;
        color: white;
        opacity: 0.8;
    }

    @keyframes tour-resize-grow {
        0%, 100% { width: 80px; height: 50px; }
        50% { width: 120px; height: 60px; }
    }

    /* Hide demo animation */
    .tour-demo-hide {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .tour-demo-hide .tour-demo-widget {
        animation: tour-hide-drop 2.5s ease-in-out infinite;
    }

    .tour-demo-trash {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border: 2px dashed #fca5a5;
        border-radius: 20px;
        color: #ef4444;
        font-size: 11px;
        font-weight: 500;
        background: #fef2f2;
        animation: tour-trash-pulse 2.5s ease-in-out infinite;
    }

    @keyframes tour-hide-drop {
        0%, 30% { transform: translateY(0); opacity: 1; }
        70%, 100% { transform: translateY(30px); opacity: 0.3; }
    }

    @keyframes tour-trash-pulse {
        0%, 30% { transform: scale(1); background: #fef2f2; }
        70%, 100% { transform: scale(1.05); background: #fee2e2; }
    }

    /* Cursor animation */
    .tour-demo-cursor {
        position: absolute;
        width: 20px;
        height: 20px;
        pointer-events: none;
    }

    /* Contribute demo animation */
    .tour-demo-contribute {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .tour-demo-plus-btn {
        width: 32px;
        height: 32px;
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
        animation: tour-plus-pulse 1.5s ease-in-out infinite;
    }

    @keyframes tour-plus-pulse {
        0%, 100% { transform: scale(1); box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4); }
        50% { transform: scale(1.15); box-shadow: 0 4px 16px rgba(245, 158, 11, 0.6); }
    }

    .tour-demo-form {
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        animation: tour-form-appear 2s ease-in-out infinite;
        opacity: 0;
    }

    @keyframes tour-form-appear {
        0%, 30% { opacity: 0; transform: translateX(-10px); }
        50%, 80% { opacity: 1; transform: translateX(0); }
        100% { opacity: 0; transform: translateX(-10px); }
    }

    .tour-demo-form-input {
        width: 100px;
        height: 8px;
        background: #f3f4f6;
        border-radius: 4px;
    }

    .tour-demo-form-input.long {
        width: 80px;
        height: 16px;
    }

    .tour-demo-form-btn {
        width: 40px;
        height: 16px;
        background: linear-gradient(135deg, #1A237E 0%, #3949AB 100%);
        border-radius: 4px;
        align-self: flex-end;
    }

    /* Modal demo shared styles */
    .tour-demo-modal {
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        animation: tour-modal-appear 2.5s ease-in-out infinite;
        width: 200px;
    }

    @keyframes tour-modal-appear {
        0%, 20% { opacity: 0; transform: scale(0.9) translateY(10px); }
        35%, 85% { opacity: 1; transform: scale(1) translateY(0); }
        100% { opacity: 0; transform: scale(0.9) translateY(10px); }
    }

    .tour-demo-modal-header {
        padding: 8px 10px;
        border-bottom: 1px solid #e5e7eb;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .tour-demo-modal-title {
        font-size: 11px;
        font-weight: 600;
        color: #1f2937;
    }

    .tour-demo-modal-close {
        width: 14px;
        height: 14px;
        color: #9ca3af;
    }

    .tour-demo-modal-body {
        padding: 10px;
    }

    .tour-demo-modal-row {
        margin-bottom: 8px;
    }

    .tour-demo-modal-label {
        font-size: 9px;
        color: #6b7280;
        margin-bottom: 3px;
        display: block;
    }

    .tour-demo-modal-input {
        width: 100%;
        height: 20px;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        font-size: 9px;
        color: #374151;
        padding: 0 6px;
        display: flex;
        align-items: center;
    }

    .tour-demo-modal-input.select {
        justify-content: space-between;
    }

    .tour-demo-modal-input.select::after {
        content: '▼';
        font-size: 6px;
        color: #9ca3af;
    }

    .tour-demo-modal-textarea {
        width: 100%;
        height: 28px;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        font-size: 8px;
        color: #9ca3af;
        padding: 4px 6px;
    }

    .tour-demo-modal-footer {
        padding: 8px 10px;
        border-top: 1px solid #e5e7eb;
        display: flex;
        justify-content: flex-end;
        gap: 6px;
    }

    .tour-demo-modal-btn {
        padding: 4px 10px;
        border-radius: 4px;
        font-size: 9px;
        font-weight: 500;
    }

    .tour-demo-modal-btn.cancel {
        background: white;
        border: 1px solid #e5e7eb;
        color: #6b7280;
    }

    .tour-demo-modal-btn.danger {
        background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
        color: white;
        border: none;
    }

    .tour-demo-modal-btn.success {
        background: linear-gradient(135deg, #059669 0%, #10b981 100%);
        color: white;
        border: none;
    }

    .tour-demo-modal-btn.primary {
        background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
        color: white;
        border: none;
    }

    .tour-demo-modal-btn.purple {
        background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
        color: white;
        border: none;
    }

    /* Delete modal specific */
    .tour-demo-modal.delete .tour-demo-modal-header {
        background: #fef2f2;
    }

    .tour-demo-modal.delete .tour-demo-modal-title {
        color: #dc2626;
    }

    /* Pay modal specific */
    .tour-demo-modal.pay .tour-demo-modal-header {
        background: #ecfdf5;
    }

    .tour-demo-modal.pay .tour-demo-modal-title {
        color: #059669;
    }

    /* Mail modal specific */
    .tour-demo-modal.mail .tour-demo-modal-header {
        background: #eff6ff;
    }

    .tour-demo-modal.mail .tour-demo-modal-title {
        color: #2563eb;
    }

    /* Update modal specific */
    .tour-demo-modal.update .tour-demo-modal-header {
        background: #f5f3ff;
    }

    .tour-demo-modal.update .tour-demo-modal-title {
        color: #7c3aed;
    }

    /* Icon in header */
    .tour-demo-modal-icon {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }

    .tour-demo-header-left {
        display: flex;
        align-items: center;
    }

    /* Checkbox style for modal */
    .tour-demo-modal-checkbox {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 8px;
        color: #6b7280;
    }

    .tour-demo-modal-checkbox-box {
        width: 10px;
        height: 10px;
        border: 1px solid #d1d5db;
        border-radius: 2px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tour-demo-modal-checkbox-box.checked {
        background: #3b82f6;
        border-color: #3b82f6;
    }

    .tour-demo-modal-checkbox-box.checked::after {
        content: '✓';
        font-size: 7px;
        color: white;
    }

    /* Add Invoice Line modal - larger modal */
    .tour-demo-modal.invoice-line {
        width: 280px;
    }

    .tour-demo-modal.invoice-line .tour-demo-modal-header {
        background: linear-gradient(135deg, #1A237E 0%, #3949AB 100%);
    }

    .tour-demo-modal.invoice-line .tour-demo-modal-title {
        color: white;
    }

    .tour-demo-modal.invoice-line .tour-demo-modal-close {
        color: rgba(255,255,255,0.7);
    }

    .tour-demo-modal-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 6px;
    }

    .tour-demo-modal-grid .full-width {
        grid-column: 1 / -1;
    }

    .tour-demo-modal-chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 8px;
        background: #f3f4f6;
        border-radius: 4px;
        font-size: 8px;
        color: #374151;
    }

    .tour-demo-modal-chip.active {
        background: #dbeafe;
        color: #1d4ed8;
    }

    .tour-demo-modal-service {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 6px;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        font-size: 8px;
        color: #374151;
    }

    .tour-demo-modal-service-close {
        width: 10px;
        height: 10px;
        color: #9ca3af;
    }

    /* Preview Mail demo - skeleton style */
    .tour-demo-email {
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        width: 240px;
    }

    .tour-demo-email-header {
        padding: 10px 12px;
        border-bottom: 1px solid #e5e7eb;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .tour-demo-email-logo {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .tour-demo-email-logo-icon {
        width: 20px;
        height: 20px;
        background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
        border-radius: 50%;
    }

    .tour-demo-email-logo-text {
        width: 50px;
        height: 10px;
        background: #1A237E;
        border-radius: 2px;
    }

    .tour-demo-email-support {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 3px;
    }

    .tour-demo-skeleton {
        background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
        background-size: 200% 100%;
        animation: tour-skeleton-pulse 1.5s ease-in-out infinite;
        border-radius: 3px;
    }

    @keyframes tour-skeleton-pulse {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .tour-demo-email-body {
        padding: 12px;
    }

    .tour-demo-email-title {
        height: 12px;
        width: 180px;
        margin-bottom: 10px;
        background: #dbeafe;
        border-radius: 3px;
    }

    .tour-demo-email-greeting {
        height: 8px;
        width: 120px;
        margin-bottom: 8px;
    }

    .tour-demo-email-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin-bottom: 12px;
    }

    .tour-demo-email-content-line {
        height: 6px;
        border-radius: 2px;
    }

    .tour-demo-email-table {
        width: 100%;
        margin-bottom: 12px;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        overflow: hidden;
    }

    .tour-demo-email-table-header {
        display: grid;
        grid-template-columns: 20px 1fr 50px 50px;
        gap: 4px;
        padding: 6px 8px;
        background: #f3f4f6;
        border-bottom: 1px solid #e5e7eb;
    }

    .tour-demo-email-table-header-cell {
        height: 8px;
        background: #d1d5db;
        border-radius: 2px;
    }

    .tour-demo-email-table-row {
        display: grid;
        grid-template-columns: 20px 1fr 50px 50px;
        gap: 4px;
        padding: 6px 8px;
        border-bottom: 1px solid #f3f4f6;
    }

    .tour-demo-email-table-cell {
        height: 6px;
        border-radius: 2px;
    }

    .tour-demo-email-table-total {
        display: flex;
        justify-content: space-between;
        padding: 6px 8px;
        background: #f8fafc;
    }

    .tour-demo-email-table-total-label {
        height: 8px;
        width: 60px;
        background: #1A237E;
        border-radius: 2px;
    }

    .tour-demo-email-table-total-value {
        height: 8px;
        width: 50px;
        background: #1A237E;
        border-radius: 2px;
    }

    .tour-demo-email-payment {
        background: #f9fafb;
        padding: 8px;
        border-radius: 4px;
        margin-bottom: 10px;
    }

    .tour-demo-email-payment-title {
        height: 8px;
        width: 100px;
        background: #374151;
        border-radius: 2px;
        margin-bottom: 6px;
    }

    .tour-demo-email-payment-lines {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .tour-demo-email-footer {
        padding: 8px 12px;
        border-top: 3px solid #dc2626;
        background: #f9fafb;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .tour-demo-email-download {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 50px;
        height: 18px;
        background: #1A237E;
        border-radius: 4px;
    }

    /* Mobile responsive styles */
    @media (max-width: 767px) {
        .tour-popover-container {
            padding: 16px;
            width: calc(100vw - 20px);
            max-width: calc(100vw - 20px);
        }

        .tour-popover-container h3 {
            font-size: 15px;
            margin-bottom: 6px;
        }

        .tour-popover-container p {
            font-size: 13px;
            line-height: 1.5;
        }

        .tour-btn {
            padding: 7px 14px;
            font-size: 13px;
        }

        .tour-footer {
            flex-direction: column;
            gap: 12px;
            align-items: flex-start;
        }

        .tour-footer-buttons {
            width: 100%;
            justify-content: flex-end;
        }

        .tour-keyboard-hint {
            display: none; /* Hide keyboard hints on mobile */
        }

        .tour-demo {
            margin: 8px 0 12px 0;
            padding: 12px;
        }
    }
`
